/**
 * Built-in English string catalog.
 * These are the canonical keys that customers can override via CH_languages.
 * Keys match the strings hardcoded in index.html.
 */
export const defaultStrings: Record<string, string> = {
    // Captcha
    'captcha-message': "Please verify you're human to continue",

    // Blocked
    'blocked-title': 'Access Denied',
    'blocked-description': "You've been blocked due to suspicious activity.",

    // Room full
    'room-full-title': 'Queue Full',
    'room-full-description': "We're at capacity. You'll be let in when a spot opens up.",

    // Countdown
    'countdown-label': 'Queue opens in',
    'countdown-hours': 'hrs',
    'countdown-minutes': 'min',
    'countdown-seconds': 'sec',
    'countdown-message': "Stay on this page. You'll get a random position when the queue opens.",

    // Position
    'position-label': 'Your position',
    'checking-in': 'Checking in!',
    'shuffling-positions': 'Shuffling positions!',

    // Estimates
    'estimate-almost': 'Almost there!',
    'estimate-over-hour': 'More than an hour',
    'estimate-minutes': 'Approximately {n} minutes',
    'estimate-eta': 'ETA: {time}',

    // Priority
    'priority-title': 'Got a priority code?',
    'priority-placeholder': 'Enter code',
    'priority-apply': 'Apply',
    'priority-success': 'Code applied!',
    'priority-error': 'Invalid code',

    // Stock
    'stock-remaining': 'items remaining',
    'stock-sold-out': 'Sold out',

    // Session info
    'sessions-expire-message': "Keep this window open. You'll move forward automatically.",
    'sessions-timeout-message': "You'll be redirected when it's your turn. You have {n} minutes to complete your transaction.",

    // Email
    'email-change-title': 'Change notification email',
    'email-notify-title': "Get notified when it's your turn",
    'email-placeholder': 'your@email.com',
    'email-notify-btn': 'Notify me',
    'email-cancel-btn': 'Cancel',
    'email-confirmation': "We'll email {email}",
    'email-change-btn': 'Change',
    'email-terms': 'Your email address will be stored temporarily to notify you when your queue session ends. It will only be used for this purpose and deleted immediately after.',

    // Footer
    'footer-id-label': 'ID:',
    'footer-copied': 'Copied!',
    'footer-copy-title': 'Press Enter to copy',
    'footer-last-request': 'Last check in:',
    'footer-powered-by': 'Powered by',
    'footer-new-tab-sr': '(opens in new tab)',

    // Aria labels
    'progress-aria': 'Queue progress',
    'checking-in-aria': 'Checking in progress',
    'email-aria': 'Email address',
    'email-submitting-aria': 'Submitting',

    // Screen reader announcements
    'announcement-position-estimate': 'Position {position}, estimated wait {estimate} minutes',
    'announcement-position': 'Position {position}',
};
